import { ChatMessagesProps } from '@/interfaces';
import { createContext } from 'react';

interface ChatMessagesInterface {
	chatMessages: ChatMessagesProps[];
	setChatMessages:
		| React.Dispatch<React.SetStateAction<ChatMessagesProps[]>>
		| ((value: ChatMessagesProps[]) => void);

	isLoading: boolean;
	setIsLoading:
		| React.Dispatch<React.SetStateAction<boolean>>
		| ((value: boolean) => void);
	isConversationOver: boolean;
	setIsConversationOver:
		| React.Dispatch<React.SetStateAction<boolean>>
		| ((value: boolean) => void);
	date: string;
	setDate:
		| React.Dispatch<React.SetStateAction<string>>
		| ((value: string) => void);
}

export const ChatMessagesContext = createContext<ChatMessagesInterface>({
	chatMessages: [],
	setChatMessages: () => null,
	isLoading: false,
	setIsLoading: () => null,
	isConversationOver: false,
	setIsConversationOver: () => null,
	date: '',
	setDate: () => null,
});
